import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function HerokuIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M21.375 2.60625C21.375 1.36875 20.3812 0.375 19.1437 0.375H4.85625C3.61875 0.375 2.625 1.36875 2.625 2.60625V21.4125C2.625 22.65 3.61875 23.6437 4.85625 23.6437H19.1625C20.4 23.6437 21.3937 22.65 21.3937 21.4125V2.60625H21.375ZM20.625 2.625V21.2438C20.625 22.125 19.9688 22.875 19.0875 22.875H4.96875C4.0875 22.875 3.375 22.125 3.375 21.2438V2.625C3.375 1.74375 4.10625 1.125 4.96875 1.125H19.0687C19.95 1.125 20.6437 1.8 20.6437 2.68125L20.625 2.625ZM6.9375 20.3812L9.58125 17.7375L6.9375 15.0938V20.3812ZM9.5625 8.9625V3.45L6.95625 3.46875C6.95625 3.46875 6.975 12.075 6.99375 12.0375C15.0187 8.90625 14.4375 11.1375 14.4375 11.1375V20.4L14.4188 20.4375H16.875V11.1562C16.875 6.075 9.5625 8.9625 9.5625 8.9625ZM13.125 6.75H15.9C17.4 4.875 17.9062 3.5625 17.9062 3.5625H15.0375C15.0375 3.5625 14.1188 5.625 13.125 6.75Z"
        fill="#6762A6"
      />
    </svg>
  );
};
